import React, { useMemo } from "react";
import { DecorativeBackgroundImage } from "components/images";
import { Section } from "components/section";
import { type CaseStudySimple } from "lib/sanity";
import { Diptych } from "ui/diptych";
import { type FilterTabProps, FilterTabs } from "ui/tabs";
import { getCaseStudyIndustryColor } from "utils";
import { Button } from "ui/button";

export function FeaturedCaseStudiesSection({ caseStudies }: { caseStudies: CaseStudySimple[] }) {
  const featuredCaseStudyTabs: FilterTabProps[] = useMemo(() => {
    return caseStudies.map((caseStudy) => {
      return {
        label: caseStudy.customer.name,
        logo: caseStudy.customer.logoMonoUrl ?? caseStudy.customer.logoUrl,
        items: (
          <Diptych
            size="lg"
            direction="right"
            chip={{ text: caseStudy.industry.name, variant: getCaseStudyIndustryColor(caseStudy.industry.slug) }}
            title={caseStudy.title}
            titleAs="h2"
            titleSize="sm"
            actions={
              <Button hasRightChevron href={`/customers/${caseStudy.customer.slug}`}>
                Read the story
              </Button>
            }
            media={
              <DecorativeBackgroundImage
                src={caseStudy.fullImageUrl}
                style={{ objectFit: "cover", objectPosition: "right" }}
              />
            }
          />
        ),
      };
    });
  }, [caseStudies]);

  return (
    <Section my="0" pt="biggest" pb="huger">
      <FilterTabs variant="logo" tabs={featuredCaseStudyTabs} />
    </Section>
  );
}
